function updateColorSwatch(id, element) {
  const variantColorOption = document.querySelector(`input[id*='${id}']`);
  const mediaId = element.getAttribute("data-media-id");

  // check if the variant is not already selected
  if (variantColorOption && !variantColorOption.checked) {
    variantColorOption.checked = true;
    variantColorOption.dispatchEvent(new Event("change", { bubbles: true }));
  }

  scrollToImage(mediaId);
  const currentActiveItem = document.querySelector(
    "product-gallery-navigation button[aria-current='true']"
  );
  const newActiveItem = document.querySelector(
    `product-gallery-navigation button[data-media-id="${mediaId}"]`
  );

  if (newActiveItem && currentActiveItem !== newActiveItem) {
    currentActiveItem
      ? currentActiveItem.setAttribute("aria-current", "false")
      : newActiveItem.setAttribute("aria-current", "true");
  }
}

function scrollToImage(mediaId) {
  const galleryMediaItem = document.querySelector(
    `.product-gallery__media[data-media-id="${mediaId}"]`
  );
  if (galleryMediaItem) {
    galleryMediaItem.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

function selectedColorSwatchVariant() {
  const checkedColor = document.querySelector(
    `input[id*='main-option1-']:checked`
  );

  if (checkedColor) {
    const id = checkedColor.id.split("main-option1-")[1];
    const colorOption = document.querySelector(
      `input[id='color-option1-${id}']`
    );

    if (colorOption) {
      colorOption.click();
    }
  }
}

document.addEventListener("DOMContentLoaded", selectedColorSwatchVariant);

document.addEventListener("DOMContentLoaded", function () {
  const scrollArea = document.querySelector(
    ".product-gallery .product-gallery__carousel"
  );

  function refreshDOM() {
    const parent = scrollArea.parentNode;
    parent.removeChild(scrollArea);

    if (scrollArea.hasAttribute("adaptive-height")) {
      scrollArea.removeAttribute("adaptive-height", "");
    }
    scrollArea.classList.remove("scroll-area");
    parent.appendChild(scrollArea);
  }

  if (window.innerWidth > 1000) {
    const announcementBar = document.querySelector(
      ".shopify-section-group-header-group.shopify-section--announcement-bar"
    );
    const headerBar = document.querySelector(
      ".shopify-section-group-header-group.shopify-section--header"
    );

    refreshDOM();

    const availableHeight =
      window.innerHeight -
      announcementBar.clientHeight -
      headerBar.clientHeight -
      55;

    scrollArea.style.setProperty(
      "--scroll-area-max-height",
      availableHeight + "px"
    );
  }
});
